<div class="modal l-wrapper {{ additionalClass }}"
     [ngClass]="{'modal--mobile': breakPoint.isMobile && (layout$ | async) === layouts.Fresh,
      'modal--android': breakPoint.isAndroid, 'is-hide-head': isHideHead}"
     appModalSwipe>
  <div class="modal__overlay" (click)="onClose()" appOverlaySwipe></div>
    <div class="modal__container" appBottomSwipeSheet (swipeAnimationEnd)="onClose()">
      <div class="modal__content">

        <div class="modal__head l-wrapper">
          <div class="modal__title h2">{{ title }}</div>
          <ng-container [ngSwitch]="additionalClass">
            <button *ngSwitchCase="'_order'" class="button-icon button-icon--th-ctrl" (click)="onClose()">
              <i class="icomoon icomoon--arrow-left"></i>
            </button>
            <div *ngSwitchDefault class="modal__close _round">
              <button class="button-icon button-icon--th-main" (click)="onClose()">
                <mat-icon class="material-icons-outlined">close</mat-icon>
              </button>
            </div>
          </ng-container>
        </div>

        <div class="modal__body l-wrapper" [ngClass]="{'_form': isSmall}">
          <ng-content></ng-content>
        </div>

        <div class="modal__footer l-wrapper" [ngClass]="{'is-dialog': isDialog}">
          <ng-content select="[footer]"></ng-content>
        </div>

      </div>
    </div>
</div>
